import type { EbookMove, EbookQuestion } from '@wx-weiqi/contracts';

/** Return to the learner's previous turn; manual demonstration removes only one move. */
export function ebookTrialUndoPly(
  moves: readonly EbookMove[],
  mode: EbookQuestion['mode'],
  learner: EbookQuestion['currentPlayer'],
) {
  if (mode === 'MANUAL') return Math.max(0, moves.length - 1);
  for (let index = moves.length - 1; index >= 0; index--)
    if (moves[index]?.color === learner) return index;
  return 0;
}

/** PENDING_REVIEW is the server's live manual-preview state, not a submission. */
export function ebookTrialCompleted(
  mode: EbookQuestion['mode'],
  status: string | undefined,
  manualSubmitted: boolean,
) {
  return mode === 'MANUAL' ? manualSubmitted : status !== undefined && status !== 'CONTINUE';
}
